import { useState } from "react";
import WIP from "./WIP";

function Stuff(){
  const [WebpageName] = useState('Stuff');
  return(
      <WIP WebpageName={WebpageName}/>
  )
}

export default Stuff;